import React from 'react';

type ToggleIconProps = {
  className?: string;
  onClick: () => void;
};

export const ToggleIcon: React.FC<ToggleIconProps> = ({
  className = '',
  onClick,
}: ToggleIconProps): JSX.Element => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <circle cx="15" cy="15" r="15" fill="#ACBBF5" />
      <rect
        x="17.0713"
        y="8"
        width="2"
        height="10"
        rx="1"
        transform="rotate(45 17.0713 8)"
        fill="white"
      />
      <rect
        x="18.4854"
        y="20.7275"
        width="2"
        height="10"
        rx="1"
        transform="rotate(135 18.4854 20.7275)"
        fill="white"
      />
    </svg>
  );
};
